import { useEffect, useState } from "react";
import LoadingComponent from "../../widgets/LoadingComponent";
import { Breadcrumb, Button, FloatingLabel, Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import AsyncSelect from 'react-select/async';
import { getData } from "../../api/ApiRest";
import { FaDownload, FaSearch } from "react-icons/fa";
import { exportToExcel } from "react-json-to-excel";
import { formatDateddMMMyyyy, formatDateddMMyyyyhhmm } from "../../widgets/DateTime";
import { formatNumber } from "../../widgets/FormatNumber";


function EmisionGeneral() {
    const [loading, setLoading] = useState(false);
    const [dataBuscar, setDataBuscar] = useState({
        Desde: new Date().toISOString().split('T')[0],
        Hasta: new Date().toISOString().split('T')[0],
        Cliente: ''
    });

    const [registros, setRegistros] = useState([]);
    const [auditoria, setAuditoria] = useState([]);

    const adminTae = useSelector((state) => state.auth.AdminTae);
    const companyId = useSelector((state) => state.auth.CompanyId);

    useEffect(() => {
        getInfoIndex();
    }, [])

    const getInfoIndex = () => {
        setLoading(true);

        getData('api/Cliente/Dashboard/GetInfoExcel').then(response => {
            setAuditoria(response.list);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    const buscarRegistros = (event) => {
        event.preventDefault();
        setLoading(true);

        getData('api/Cliente/Dashboard/GetReporteGeneralExcel', {
            desde: dataBuscar.Desde,
            hasta: dataBuscar.Hasta,
            companyId: dataBuscar.Cliente || ''
        }).then(response => {
            if (response.status) {
                setRegistros(response.registros);
                exportToExcel(response.registros, 'EmisionGeneral');

                setAuditoria((prev) => [...prev, response.objeto]);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    const companieSearchSelect2 = async (Param) => {
        return await getData('api/Configuracion/Company/Select2Company',
            { param: Param }, false).then(response => {
                return response.companies;
            }, error => {
                return [];
            })
    }

    return <div className='BodyComponent'>
        <Breadcrumb color='black'>
            <Breadcrumb.Item style={{ fontSize: 14 }} >Home</Breadcrumb.Item>
            <Breadcrumb.Item style={{ fontSize: 14 }} active={true}>General</Breadcrumb.Item>
        </Breadcrumb>

        {<LoadingComponent Loading={loading} />}

        <Form onSubmit={buscarRegistros}>
            <div className='row'>
                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="Fecha"
                        label="Fecha desde"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="date"
                            autoComplete='off'
                            required={true}
                            placeholder="Emision desde"
                            value={dataBuscar.Desde}
                            onChange={value => {
                                setDataBuscar({
                                    ...dataBuscar,
                                    Desde: value.target.value
                                })
                            }}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="Fecha hasta"
                        label="Fecha hasta"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="date"
                            autoComplete='off'
                            required={true}
                            placeholder="Emision hasta"
                            value={dataBuscar.Hasta}
                            onChange={value => {
                                setDataBuscar({
                                    ...dataBuscar,
                                    Hasta: value.target.value
                                })
                            }}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>

                {adminTae === 'true' ?
                    <div className='col-md-5'>
                        <AsyncSelect cacheOptions defaultOptions
                            menuPosition='fixed'
                            noOptionsMessage={() => 'Escriba para iniciar la busqueda'}
                            placeholder="Cliente"
                            isClearable={true}
                            loadOptions={companieSearchSelect2}
                            onChange={value => {
                                if (value === null)
                                    setDataBuscar({ ...dataBuscar, Cliente: '' })
                                else
                                    setDataBuscar({ ...dataBuscar, Cliente: value.value })
                            }}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    minHeight: 50
                                })
                            }}
                        />
                    </div>
                    : null}

                <div className='col-md-1'>
                    <Button variant='primary' type='submit' size="sm">
                        <FaDownload size={'0.8rem'} />
                    </Button>
                </div>

            </div>
        </Form>

        <div className="primary">
            <strong style={{ backgroundColor: 'rgba(144, 203, 216, 1)' }}>Máximo de registros por archivo de excel 130.000</strong>
        </div>

        <br />

        <table className='table table-borderless table-hover'>
            <thead>
                <tr>
                    <th className="estilo-encabezado">Fecha generado</th>
                    <th className="estilo-encabezado">Rango de fechas</th>
                    {adminTae === 'true' ? <th className="estilo-encabezado">Empresa</th> : null}
                    <th className="estilo-encabezado">Usuario</th>
                    <th className="estilo-encabezado">Registros</th>
                </tr>
            </thead>
            <tbody>
                {auditoria.map((item, index) => (
                    <tr key={index}>
                        <td style={{ textAlign: 'center' }}>
                            {formatDateddMMyyyyhhmm(item.fechahora)}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            {formatDateddMMMyyyy(item.desde)} / {formatDateddMMMyyyy(item.hasta)}
                        </td>
                        {adminTae === 'true' ? <td style={{ textAlign: 'center' }}>
                            {item.empresa}
                        </td> : null}
                        <td style={{ textAlign: 'center' }}>
                            {item.usuario}
                        </td>
                        <td style={{ textAlign: 'right' }}>
                            {formatNumber(item.cantidadRegistros)}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>

    </div>

}

export default EmisionGeneral;